class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
    document.addEventListener('fg-cart:auto-updated ', () => {
      this.rerenderCart();
    })
    document.addEventListener('fg-gifts:updated', () => {
      this.rerenderCart();
    });
  }

  rerenderCart() {
    fetch(window.location.pathname + this.dataset.url).then((response) => {
      return response.text();
    }).then((response) => {
      const html = new DOMParser().parseFromString(response, 'text/html');
      this.innerHTML = html.querySelector('.shopify-section').innerHTML;
    })
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }

    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);


class MiniCartForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.agreementCheckbox = this.querySelector('[data-agreement]')
    this.submitButton = this.querySelector('[type="submit"]');

    if (!this.agreementCheckbox) return;

    this.submitButton.classList.add('disabled');
    this.form.addEventListener('submit', (event) => {
      if (!this.agreementCheckbox.checked) event.preventDefault();

      this.agreementCheckbox.classList.toggle('animation--error', !this.agreementCheckbox.checked);

      if (!this.agreementCheckbox.checked) {
        this.agreementCheckbox.classList.remove('animation--error')

        setTimeout(() => {
          this.agreementCheckbox.classList.add('animation--error')
        }, 0)
      }
    })

    this.agreementCheckbox.addEventListener('change', () => {
      this.submitButton.classList.toggle('disabled', !this.agreementCheckbox.checked);
    })
  }
}

customElements.define('mini-cart-form', MiniCartForm);




class ProductFormCart extends ProductForm {
  constructor() {
    super();

    this.opener = this.querySelector('[data-opener]');

    this.opener.addEventListener('click', () => this.setAttribute('aria-expended', 'true'));

    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-closer]') || event.target === event.currentTarget)
        this.setAttribute('aria-expended', 'false')
    })
  }
}

customElements.define('product-form-cart', ProductFormCart);